import React from "react";
import { CheckCircle2Icon } from "lucide-react";
import { CHECKOUT_URL } from "../../data/content";
type CtaButtonProps = {
  label: string;
  id?: string;
  className?: string;
  compact?: boolean;
};
export function CtaButton({
  label,
  id,
  className = "",
  compact = false
}: CtaButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta text-center font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_10px_30px_-8px_rgba(31,157,85,0.6)] ring-1 ring-inset ring-white/15 transition-[transform,background-color] duration-150 ease-out hover:bg-cta-dark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 ${compact ? "px-4 py-3.5 text-[15px]" : "px-5 py-5 text-[17px] sm:px-8 sm:py-6 sm:text-xl"} ${className}`} data-id="element-347" data-mp="20tiuwo9xcm3w">
      <CheckCircle2Icon className={`${compact ? "h-5 w-5" : "h-6 w-6 sm:h-7 sm:w-7"} shrink-0`} aria-hidden="true" data-id="element-348" data-mp="18668qf7oegb4" />
      <span data-id="element-349" data-mp="2hfryhkuub4by">{label}</span>
    </a>;
}